export const getUsers = state => state.users;
export const getIdentityToken = state => state.identityToken;
